import React, { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { getSubscriber as getSubcriberAction } from '@actions/subscriber'
import useStyles from './subscriber.style'

import Splash from '@components/splash/splash.component'
import TagList from '@components/tag-list/tag-list.component'

const Subscriber = () => {
  const classes = useStyles()
  const { id } = useParams()

  const dispatch = useDispatch()

  const response = useSelector(state => state.subscriber)

  useEffect(() => {
    dispatch(getSubcriberAction(id))
  }, [dispatch, id])

  const renderName = () => {
    if (!lastname && !firstname) return null
    if (!lastname && firstname) return firstname
    if (lastname && !firstname) return lastname

    return `${lastname}, ${firstname}`
  }

  if (response.isLoading) return <Splash />

  const {
    emails,
    firstname,
    groups,
    lastname,
    sms: smss,
    username,
    voice: voices
  } = response

  const COLUMN_DATA = [
    {
      data: emails || [],
      key: 'email',
      label: 'Email:',
      linkify: true,
      linkPrefix: 'mailto:'
    },
    {
      data: smss || [],
      key: 'sms',
      label: 'SMS:',
      linkify: true,
      linkPrefix: 'sms:'
    },
    {
      data: groups || [],
      key: 'group',
      label: 'Groups:',
      linkify: false,
      linkPrefix: null
    },
    {
      data: voices || [],
      key: 'voice',
      label: 'Voice:',
      linkify: true,
      linkPrefix: 'tel:'
    }
  ]

  return (
    <div>
      <div className={classes.card}>
        <div
          className={classes.header}
        >
          <figure
            className={classes.image}
            style={{ width: 100 }}
          >
            <img
              alt='icon'
              src={require('images/omnilert_logo_flat_dark.png')}
            />
          </figure>
        </div>
        <div className={classes.cardContent}>
          <div className={classes.media}>
            <div className='media-item'>
              <h4 className={classes.title}>{renderName()}</h4>
              <h6 className={classes.subTitle}>{username}</h6>
            </div>
          </div>
          {COLUMN_DATA.map((item, index) => (
            <div
              key={`${item.key}-${index}`}
              className={classes.columns}
            >
              <div className={classes.columnLabel}>
                <div>
                  <label>{item.label}</label>
                </div>
              </div>
              <div className={classes.columnItem}>
                <TagList
                  data={item.data}
                  linkPrefix={item.linkPrefix}
                  linkify={item.linkify}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Subscriber
